module.exports = __webpack_public_path__ + "static/media/handbook.0e302368.jpg";